var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "tw-flex tw-flex-1 tw-flex-col parent-league-container" },
    [
      _c(
        "v-row",
        { staticClass: "tw-flex-grow-0" },
        [
          _c("v-col", { attrs: { cols: "12", md: "10" } }, [
            _c("h2", { staticClass: "tw-text-2xl tw-text-gray-800" }, [
              _vm._v("Select Parent Leagues")
            ])
          ]),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "2" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "tw-mr-4 tw-uppercase tw-w-full",
                  attrs: {
                    color: "primary",
                    disabled: !_vm.parentLeagues.length
                  },
                  on: { click: _vm.nextStep }
                },
                [_vm._v(" Continue ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "tw-flex-grow-0" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "6" } },
            [
              _c(
                "label",
                {
                  staticClass: "tw-text-sm tw-text-footy-red mb-1",
                  attrs: { for: "search-field" }
                },
                [_vm._v("Search")]
              ),
              _c("v-text-field", {
                staticClass: "tw-mt-1",
                attrs: {
                  id: "search-field",
                  outlined: "",
                  "background-color": "white",
                  dense: ""
                },
                model: {
                  value: _vm.searchField,
                  callback: function($$v) {
                    _vm.searchField = $$v
                  },
                  expression: "searchField"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        {
          staticClass:
            "tw-w-full tw-flex tw-items-center tw-flex-grow-0 filters-container"
        },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "2" } },
            [
              _c(
                "label",
                {
                  staticClass: "tw-text-sm tw-text-footy-red mb-1",
                  attrs: { for: "country-filter" }
                },
                [_vm._v("Country")]
              ),
              _c("v-select", {
                attrs: {
                  items: _vm.countryFilterOptions,
                  label: "Country",
                  "item-text": "name",
                  "item-value": "id",
                  solo: "",
                  dense: ""
                },
                model: {
                  value: _vm.filters.country,
                  callback: function($$v) {
                    _vm.$set(_vm.filters, "country", $$v)
                  },
                  expression: "filters.country"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "2" } },
            [
              _c(
                "label",
                {
                  staticClass: "tw-text-sm tw-text-footy-red mb-1",
                  attrs: { for: "cities-filter" }
                },
                [_vm._v("Cities")]
              ),
              _c("v-select", {
                staticClass: "tw-w-full",
                attrs: {
                  items: _vm.cityFilterOptions,
                  label: "City",
                  "item-text": "name",
                  "item-value": "id",
                  solo: "",
                  multiple: "",
                  dense: "",
                  chips: ""
                },
                on: {
                  change: function($event) {
                    return _vm.filterChange("city")
                  }
                },
                model: {
                  value: _vm.filters.cities,
                  callback: function($$v) {
                    _vm.$set(_vm.filters, "cities", $$v)
                  },
                  expression: "filters.cities"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "2" } },
            [
              _c(
                "label",
                {
                  staticClass: "tw-text-sm tw-text-footy-red mb-1",
                  attrs: { for: "venue-filter" }
                },
                [_vm._v("Venue")]
              ),
              _c("v-select", {
                staticClass: "tw-w-full",
                attrs: {
                  items: _vm.venueFilterOptions,
                  label: "Venue",
                  "item-text": "name",
                  "item-value": "id",
                  solo: "",
                  multiple: "",
                  dense: "",
                  chips: ""
                },
                model: {
                  value: _vm.filters.locations,
                  callback: function($$v) {
                    _vm.$set(_vm.filters, "locations", $$v)
                  },
                  expression: "filters.locations"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "2" } },
            [
              _c(
                "label",
                {
                  staticClass: "tw-text-sm tw-text-footy-red mb-1",
                  attrs: { for: "format-filter" }
                },
                [_vm._v("Player Type")]
              ),
              _c("v-select", {
                staticClass: "league-filter-select",
                attrs: {
                  items: _vm.formatFilterOptions,
                  label: "Player Type",
                  solo: "",
                  dense: ""
                },
                model: {
                  value: _vm.filters.playerType,
                  callback: function($$v) {
                    _vm.$set(_vm.filters, "playerType", $$v)
                  },
                  expression: "filters.playerType"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "1" } },
            [
              _c(
                "label",
                {
                  staticClass: "tw-text-sm tw-text-footy-red mb-1",
                  attrs: { for: "group-filter" }
                },
                [_vm._v("Group Sort By")]
              ),
              _c("v-select", {
                attrs: {
                  id: "group-filter",
                  items: _vm.sortByOptions,
                  label: "Group Sort By",
                  solo: "",
                  dense: ""
                },
                model: {
                  value: _vm.filters.sortBy,
                  callback: function($$v) {
                    _vm.$set(_vm.filters, "sortBy", $$v)
                  },
                  expression: "filters.sortBy"
                }
              })
            ],
            1
          ),
          _c("v-col", { attrs: { cols: "12", md: "3" } }, [
            _c(
              "div",
              { staticClass: "tw-flex tw-items-center" },
              [
                _c("v-checkbox", {
                  staticClass: "tw-ml-4 tw-mt-0 tw-pt-0",
                  attrs: { color: "primary", label: "Planned" },
                  model: {
                    value: _vm.filters.isPlanned,
                    callback: function($$v) {
                      _vm.$set(_vm.filters, "isPlanned", $$v)
                    },
                    expression: "filters.isPlanned"
                  }
                }),
                _c("v-checkbox", {
                  staticClass: "tw-ml-4 tw-mt-0 tw-pt-0",
                  attrs: { color: "primary", label: "Active" },
                  model: {
                    value: _vm.filters.isActive,
                    callback: function($$v) {
                      _vm.$set(_vm.filters, "isActive", $$v)
                    },
                    expression: "filters.isActive"
                  }
                }),
                _c("v-checkbox", {
                  staticClass: "tw-ml-4 tw-mt-0 tw-pt-0",
                  attrs: { color: "primary", label: "Finished" },
                  model: {
                    value: _vm.filters.isFinished,
                    callback: function($$v) {
                      _vm.$set(_vm.filters, "isFinished", $$v)
                    },
                    expression: "filters.isFinished"
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "tw-flex-grow-0 leagues-table-container" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              !_vm.filteredLeagues.length
                ? _c("span", { staticClass: "text-lg tw-text-gray-800" }, [
                    _vm._v("There are no leagues to show")
                  ])
                : _vm._e(),
              _vm._l(_vm.filteredLeagues, function(league, index) {
                return _c(
                  "div",
                  {
                    key: "league-" + index,
                    staticClass:
                      "tw-w-full tw-p-4 tw-flex tw-flex-row tw-flex-wrap tw-flex-grow-0 tw-justify-start tw-items-center tw-bg-white tw-cursor-pointer hover:tw-bg-blue-100 tw-mb-1 venue-table-row tw-border-2",
                    class: _vm.parentLeagues.includes(league.id)
                      ? "tw-border-footy-success-green"
                      : "tw-border-transparent",
                    on: {
                      click: function($event) {
                        return _vm.handleClick(league)
                      }
                    }
                  },
                  [
                    league.league_type === "full"
                      ? _c("v-icon", { staticClass: "tw-mr-3" }, [
                          _vm._v("mdi-format-list-numbered")
                        ])
                      : _c("v-icon", { staticClass: "tw-mr-3" }, [
                          _vm._v("mdi-view-column-outline")
                        ]),
                    _c(
                      "span",
                      {
                        staticClass: "tw-mr-6 tw-capitalize",
                        staticStyle: { width: "360px" }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm._f("shortenString")(league.display_name))
                        )
                      ]
                    ),
                    league.league_type === "full"
                      ? _c(
                          "span",
                          {
                            staticClass: "tw-mr-6 tw-capitalize",
                            staticStyle: { width: "300px" }
                          },
                          [
                            _vm._v(
                              _vm._s(league.season || "No Season") +
                                " | " +
                                _vm._s(
                                  _vm._f("dateToYear")(league.kick_off_date)
                                ) +
                                " | "
                            ),
                            _c("strong", [
                              _vm._v(_vm._s(league.locationObj.city.name))
                            ])
                          ]
                        )
                      : _c(
                          "span",
                          {
                            staticClass: "tw-mr-6 tw-capitalize",
                            staticStyle: { width: "300px" }
                          },
                          [
                            _vm._v(
                              "Mini-League | " +
                                _vm._s(
                                  _vm._f("dateToYear")(league.kick_off_date)
                                ) +
                                " | "
                            ),
                            _c("strong", [
                              _vm._v(_vm._s(league.locationObj.city.name))
                            ])
                          ]
                        ),
                    _c(
                      "span",
                      {
                        staticClass: "tw-mr-6 tw-capitalize",
                        staticStyle: { width: "160px" }
                      },
                      [_c("strong", [_vm._v(_vm._s(league.locationObj.name))])]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "tw-mr-6 tw-capitalize",
                        staticStyle: { width: "200px" }
                      },
                      [
                        _vm._v(
                          _vm._s(league.player_type) +
                            " " +
                            _vm._s(league.team_size) +
                            " "
                        )
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "tw-mr-6",
                        staticStyle: { width: "110px" }
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm._f("day")(league.day_of_week)))
                        ])
                      ]
                    ),
                    league.league_type === "mini-league"
                      ? _c(
                          "span",
                          {
                            staticClass: "tw-mr-6",
                            staticStyle: { width: "80px" }
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(league.placeholdersInLeague.length) +
                                  " Teams"
                              )
                            ])
                          ]
                        )
                      : _c(
                          "span",
                          {
                            staticClass: "tw-mr-6",
                            staticStyle: { width: "80px" }
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(league.league_teams.length) + " Teams"
                              )
                            ])
                          ]
                        ),
                    _c(
                      "div",
                      { staticClass: "tw-flex tw-flex-grow-0" },
                      [
                        league.status === "planned"
                          ? _c(
                              "v-icon",
                              {
                                staticClass: "tw-mr-2",
                                attrs: { color: "primary" }
                              },
                              [_vm._v("mdi-circle")]
                            )
                          : league.status === "active"
                          ? _c(
                              "v-icon",
                              {
                                staticClass: "tw-mr-2",
                                attrs: { color: "success" }
                              },
                              [_vm._v("mdi-circle")]
                            )
                          : _c(
                              "v-icon",
                              {
                                staticClass: "tw-mr-2",
                                attrs: { color: "secondary" }
                              },
                              [_vm._v("mdi-circle")]
                            ),
                        _c("span", { staticClass: "tw-capitalize" }, [
                          _vm._v(_vm._s(league.status))
                        ])
                      ],
                      1
                    ),
                    _c("v-spacer"),
                    _c(
                      "span",
                      { staticClass: "tw-text-red-700 tw-uppercase" },
                      [_vm._v("Results Needed")]
                    )
                  ],
                  1
                )
              })
            ],
            2
          )
        ],
        1
      ),
      _c("v-spacer"),
      _c(
        "v-row",
        { staticClass: "tw-flex-grow-0" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "3", "offset-md": "9" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "tw-mr-4 tw-uppercase tw-w-full",
                  attrs: {
                    color: _vm.parentLeagues.length ? "#4894b7" : "secondary",
                    dark: ""
                  },
                  on: { click: _vm.nextStep }
                },
                [_vm._v(" Continue ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }